import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "assets/vendors/style";
import "styles/wieldy.less";

import configureStore from "./appRedux/store";
import App from "./containers/App";
import RouteListener from "./RouteListener";

// 🔹 Créer le store UNE SEULE FOIS
const store = configureStore();

const NextApp = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* 🔹 Écoute des changements de route */}
        <RouteListener />

        {/* 🔹 Routing */}
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default NextApp;